import React, { useState, useEffect } from 'react';
import './NavBar.css';
import { Link } from 'react-router-dom'; 
import logo from '../assets/logo.png';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-logo">
        <Link to="/"><img src={logo} alt="Logo" /></Link>
      </div>

      <ul className="nav-items">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/gallery">Gallery</Link></li>
        <li><Link to="/contact">Contact</Link></li>
      </ul>

      <Link to="/donate">
        <button className="contact-btn desktop-only">Donate</button>
      </Link>

      <div className="hamburger-menu" onClick={toggleMobileMenu}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="close-btn" onClick={toggleMobileMenu}>X</div>
        <ul>
          <li><Link to="/" onClick={toggleMobileMenu}>Home</Link></li>
          <li><Link to="/about" onClick={toggleMobileMenu}>About</Link></li>
          <li><Link to="/gallery" onClick={toggleMobileMenu}>Gallery</Link></li>
          <li><Link to="/contact" onClick={toggleMobileMenu}>Contact</Link></li>
          <li>
            <Link to="/donate">
              <button className="contact-btn" onClick={toggleMobileMenu}>Donate</button>
            </Link>
          </li>
        </ul>
        <div className="mobile-menu-footer">
          Development Education & Welfare Trust
        </div>
      </div>

      {isMobileMenuOpen && <div className="overlay" onClick={toggleMobileMenu}></div>}
    </nav>
  );
};

export default Navbar;
